import {
  dateCalendar,
  calendarMonth,
  calendarISO,
  renderDateCalendar,
} from "../../components/date-picker.js";
import { can, emp } from "../../services/access.js";
import { S, save, ui } from "../store.js";
import { guardChange } from "../../features/admin/page.js";
import { toast } from "../../components/ui.js";
import { render } from "../shell.js";
import { log } from "../../services/audit.js";
import { syncDraft, readDep } from "../../features/deployments/page.js";
import { readInv } from "../../features/invoices/components.js";
import { readJV } from "../../features/accounting/voucher-form.js";
export function installChangeEvents() {
  document.addEventListener("change", (ev) => {
    const t = ev.target;
    if (
      t.hasAttribute?.("data-cal-month") ||
      t.hasAttribute?.("data-cal-year")
    ) {
      if (dateCalendar) {
        const panel = document.getElementById("date-calendar"),
          month = +panel.querySelector("[data-cal-month]").value,
          year = +panel.querySelector("[data-cal-year]").value;
        dateCalendar.month = calendarMonth(year, month);
        dateCalendar.focus = calendarISO(dateCalendar.month);
        const selector = t.hasAttribute("data-cal-month")
          ? "[data-cal-month]"
          : "[data-cal-year]";
        renderDateCalendar();
        document.querySelector("#date-calendar " + selector)?.focus();
      }
      return;
    }
    if (t.dataset.act === "role" && can("admin.users")) {
      const u = S.users.find((x) => x.id === t.dataset.id);
      {
        const g = guardChange(u, t.value, u.status);
        if (g) {
          toast(g);
          return render();
        }
      }
      const old = S.roles[u.role].name;
      u.role = t.value;
      log("Changed role", `${u.name}: ${old} → ${S.roles[u.role].name}`);
      save();
      render();
      toast("Role updated");
    }
    if (t.id === "statutory-date") {
      ui.statutoryDate = t.value;
      return render();
    }
    if (t.id === "home-task-filter") {
      ui.homeKind = t.value;
      ui.homeExpanded = false;
      return render();
    }
    if (t.id === "report-from" || t.id === "report-to") {
      ui[t.id === "report-from" ? "reportFrom" : "reportTo"] = t.value;
      return render();
    }
    if (t.id === "report-project") {
      ui.reportProject = t.value;
      return render();
    }
    if (t.id === "site-select") {
      ui.site = t.value;
      ui.reportProject = "ALL";
      ui.logProject = "ALL";
      ui.logWorker = "ALL";
      ui.logDeployment = "";
      return render();
    }
    if (t.id === "act-acc") {
      ui.actAcc = t.value;
      return render();
    }
    if (t.id === "aud-u") {
      ui.audU = t.value;
      return render();
    }
    if (t.classList && t.classList.contains("dtr-in")) {
      if (!can("dep.log")) return;
      const run = S.runs.find((x) => x.from === t.dataset.cut);
      if (!run || run.status !== "DRAFT") return render();
      const k = t.dataset.dep + "|" + t.dataset.cut,
        a = S.att[k] || (S.att[k] = { dates: [], ot: 0, nd: 0, units: 0 });
      a[t.dataset.f] = Math.max(0, +t.value || 0);
      syncDraft();
      log(
        "Time record",
        `${emp(S.deployments.find((d) => d.id === t.dataset.dep).emp).name}: ${t.dataset.f === "ot" ? "overtime hours" : t.dataset.f === "nd" ? "night hours" : "output"} ${a[t.dataset.f]}`,
      );
      save();
      return render();
    }
    if (t.closest && t.closest("#depform")) {
      readDep();
      return render();
    }
    if (t.closest("#invform")) {
      readInv();
      return render();
    }
    if (t.closest("#jvform")) {
      readJV();
      const f = document.activeElement?.id;
      render();
      if (f) document.getElementById(f)?.focus();
    }
  });
}
